import { AfterViewInit, Component, ElementRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [
        RouterOutlet
    ],
    standalone: true
})
export class AppComponent implements AfterViewInit {
    constructor(private el: ElementRef<HTMLElement>) {
    }

    ngAfterViewInit(): void {
        // componentHandler.upgradeAllRegistered(this.el.nativeElement);
    }
}
